export enum PROCESS_STATUS {
  ACTIVE = 'active',
  ANY = 'any',
  COMPLETED = 'completed'
}

/**
 * Filters used in the ProcessFilters component
 */
export class ProcessListFilter {
  siteId: string;
  definitionId: string;
  startedAfter: Date;
  startedBefore: Date;
  startedBy: string;
  assignedTo: string;
  assignee: string;
  priority: number;
  plan: string;
  type: string; // joined value, e.g. "any" or "TypeA|TypeB" (kept for compatibility)
  types: string[]; // selected types array
  handover: string;
  status: PROCESS_STATUS;

  constructor(input?: Partial<ProcessListFilter>) {
    if (input) {
      Object.assign(this, input);
    }
  }

  equalTo(filter2: ProcessListFilter): boolean {
    return (
      filter2 &&
      filter2.siteId === this.siteId &&
      filter2.definitionId === this.definitionId &&
      filter2.startedAfter === this.startedAfter &&
      filter2.startedBefore === this.startedBefore &&
      filter2.assignedTo === this.assignedTo &&
      filter2.assignee === this.assignee &&
      filter2.priority === this.priority &&
      filter2.plan === this.plan &&
      filter2.type === this.type &&
      filter2.handover === this.handover &&
      filter2.status === this.status
    );
  }
}
